export default __webpack_public_path__ + "media/images/properties_hero-9bbb4a20f5c894b330f1ffc9565a100b.jpg";